// @flow

import _ from 'lodash';
import LegalEntity from 'models/LegalEntity';

export default class CurrentUser {
  id: string;
  fullName: string;
  authenticated: boolean;
  email: string;
  roles: [];
  rolesMap: {};
  email_verified: boolean;
  whatsapp_verified: boolean;
  avatar: string;
  shortName: string;
  mobilePhone: string;
  phoneCountryCode: string;
  accepted_home_publishing_agreement: boolean;
  accepted_terms_and_conditions_agreement: Boolean;
  home_publishing_agreement_id: string;
  has_favorites: boolean;
  has_home_meetings: boolean;
  has_home_applications: boolean;
  has_rents: boolean;
  has_rented_active_or_started_home: boolean;
  legal_entity: LegalEntity;
  name: string;
  last_name: string;
  second_last_name: string;
  has_been_approved_in_any_rent: boolean;
  tenantType: string;
  re_management_company: any;
  agent_has_complete_application_form: boolean;
  agent_has_pending_application_form: boolean;
  currentAdminUser: any;
  lastCodeDate: Date;
  codeCreationDate: Date;
  agency: any;
  idAdvisor: string;
  source: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.fullName = data.full_name;
    this.name = data.name;
    this.last_name = data.last_name;
    this.second_last_name = data.second_last_name;
    this.email = data.email;
    this.authenticated = data.authenticated || false;
    this.roles = data.role_names || [];
    this.rolesMap =
      (data.role_names &&
        data.role_names.reduce((map, role) => {
          return { ...map, [role]: 1 };
        }, {})) ||
      {};
    this.email_verified = data.email_verified;
    this.avatar = data.avatar;
    this.shortName = data.short_name;
    this.mobile_phone = data.mobile_phone;
    this.phoneCountryCode = data.phone_country_code || '52';
    this.accepted_home_publishing_agreement =
      data.accepted_home_publishing_agreement || false;
    this.home_publishing_agreement_id = data.home_publishing_agreement_id || '';
    this.mobilePhone = data.mobile_phone;
    this.has_favorites = data.has_favorites;
    this.has_home_meetings = data.has_home_meetings;
    this.has_home_applications = data.has_home_applications;
    this.tenantType = data.tenant_type;
    this.has_rents = data.has_rents;
    this.has_rented_active_or_started_home =
      data.owner_has_rented_active_or_started_home;
    this.legal_entity = new LegalEntity(
      data.legal_entity ? data.legal_entity : {}
    );
    this.has_been_approved_in_any_rent = data.has_been_approved_in_any_rent;
    this.re_management_company = data.re_management_company || undefined;
    this.agent_has_complete_application_form =
      data.agent_has_complete_application_form || false;
    this.agent_has_pending_application_form =
      data.agent_has_pending_application_form || false;
    this.currentAdminUser = data.current_admin_user;
    this.accepted_terms_and_conditions_agreement =
      data.accepted_terms_and_conditions_agreement || false;

    const whatsappVerification =
      data.sign_up_verifications &&
      data.sign_up_verifications
        .reverse()
        .find(verification => verification.grant_type === 'whatsapp');
    const whatsappVerifiedAt =
      data.sign_up_verifications &&
      data.sign_up_verifications.find(
        verification =>
          verification.grant_type === 'whatsapp' && !!verification.verified_at
      );
    this.lastCodeDate =
      whatsappVerification && whatsappVerification.last_requested_at;
    this.codeCreationDate =
      whatsappVerification && whatsappVerification.created_at;
    this.whatsapp_verified = !!whatsappVerifiedAt;
    this.is_team_leader = data.is_team_leader;
    this.agency = data.agency;
    this.idAdvisor = data.idAdvisor;
    this.source = data.source;
  }

  get isOwner() {
    return _.includes(this.roles, 'owner');
  }

  get isAdvisor() {
    return _.includes(this.roles, 'advisor');
  }

  get isReAdvisor() {
    return _.includes(this.roles, 're_manager_advisor');
  }

  get isAdmin() {
    return _.includes(this.roles, 'admin');
  }
}
